var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_app_no"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "code"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["gift_app_no"],
                              maxLength: 30,
                              disabled: _vm.mainInfoDisable
                            },
                            model: {
                              value: _vm.model.code,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.model,
                                  "code",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "model.code"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["ipsys.eventName"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "name"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["ipsys.eventName"],
                              maxLength: 30,
                              disabled: _vm.mainInfoDisable
                            },
                            model: {
                              value: _vm.model.name,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.model,
                                  "name",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "model.name"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("a-col", { attrs: { span: 24 } }),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_app_pre_time"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "forecastAt"
                          }
                        },
                        [
                          _c("a-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "show-time": "",
                              "value-format": "YYYY-MM-DD HH:mm:ss",
                              placeholder:
                                _vm.language["column.pleaseChoose"] +
                                _vm.language["gift_app_pre_time"],
                              disabled: _vm.mainInfoDisable
                            },
                            model: {
                              value: _vm.model.forecastAt,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "forecastAt", $$v)
                              },
                              expression: "model.forecastAt"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_app_start_time"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "startAt"
                          }
                        },
                        [
                          _c("a-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "show-time": "",
                              "value-format": "YYYY-MM-DD HH:mm:ss",
                              placeholder:
                                _vm.language["column.pleaseChoose"] +
                                _vm.language["gift_app_start_time"],
                              disabled: _vm.mainInfoDisable
                            },
                            model: {
                              value: _vm.model.startAt,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "startAt", $$v)
                              },
                              expression: "model.startAt"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_app_end_time"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "endAt"
                          }
                        },
                        [
                          _c("a-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "show-time": "",
                              "value-format": "YYYY-MM-DD HH:mm:ss",
                              placeholder:
                                _vm.language["column.pleaseChoose"] +
                                _vm.language["gift_app_end_time"],
                              disabled: _vm.mainInfoDisable
                            },
                            model: {
                              value: _vm.model.endAt,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "endAt", $$v)
                              },
                              expression: "model.endAt"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("a-col", { attrs: { span: 24 } }),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_app_icon"],
                            labelCol: _vm.labelCol2,
                            wrapperCol: _vm.wrapperCol2,
                            prop: "icon"
                          }
                        },
                        [
                          _c("j-image-upload", {
                            attrs: {
                              "upload-source": "gift",
                              number: 1,
                              isMultiple: ""
                            },
                            model: {
                              value: _vm.model.icon,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "icon", $$v)
                              },
                              expression: "model.icon"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_app_blessing"],
                            labelCol: _vm.labelCol2,
                            wrapperCol: _vm.wrapperCol2,
                            prop: "greetings"
                          }
                        },
                        [
                          _c("a-textarea", {
                            attrs: {
                              maxLength: 200,
                              "auto-size": { minRows: 5, maxRows: 8 },
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["gift_app_blessing"]
                            },
                            model: {
                              value: _vm.model.greetings,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "greetings", $$v)
                              },
                              expression: "model.greetings"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_app_customer_info"],
                            labelCol: _vm.labelCol2,
                            wrapperCol: _vm.wrapperCol2,
                            prop: "customServiceInfo"
                          }
                        },
                        [
                          _c("a-textarea", {
                            attrs: {
                              maxLength: 200,
                              "auto-size": { minRows: 3, maxRows: 5 },
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["gift_app_customer_info"]
                            },
                            model: {
                              value: _vm.model.customServiceInfo,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "customServiceInfo", $$v)
                              },
                              expression: "model.customServiceInfo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_app_description"],
                            labelCol: _vm.labelCol2,
                            wrapperCol: _vm.wrapperCol2,
                            prop: "explanation"
                          }
                        },
                        [
                          _c("j-editor", {
                            attrs: {
                              plugins: _vm.plugins,
                              limit: 300,
                              height: 10
                            },
                            model: {
                              value: _vm.model.explanation,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "explanation", $$v)
                              },
                              expression: "model.explanation"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift.app.permission.prompt"],
                            labelCol: _vm.labelCol2,
                            wrapperCol: _vm.wrapperCol2,
                            prop: "noPermissionInfo"
                          }
                        },
                        [
                          _c("j-editor", {
                            attrs: {
                              plugins: _vm.plugins,
                              limit: 300,
                              height: 10
                            },
                            model: {
                              value: _vm.model.noPermissionInfo,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "noPermissionInfo", $$v)
                              },
                              expression: "model.noPermissionInfo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["gift_app_event_terms"],
                                labelCol: _vm.labelCol2,
                                wrapperCol: _vm.wrapperCol2,
                                prop: "clause"
                              }
                            },
                            [
                              _c("j-editor", {
                                attrs: {
                                  plugins: _vm.plugins,
                                  limit: 300,
                                  height: 10
                                },
                                model: {
                                  value: _vm.model.clause,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "clause", $$v)
                                  },
                                  expression: "model.clause"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "a-tabs",
        {
          on: { change: _vm.handleChangeTabs },
          model: {
            value: _vm.activeKey,
            callback: function($$v) {
              _vm.activeKey = $$v
            },
            expression: "activeKey"
          }
        },
        [
          _c(
            "a-tab-pane",
            {
              key: _vm.refKeys[0],
              attrs: {
                tab: " * " + _vm.language["gift_app_delivery_date"],
                forceRender: true
              }
            },
            [
              _c("j-editable-table", {
                ref: _vm.refKeys[0],
                attrs: {
                  loading: _vm.appDeliveryTable.loading,
                  columns: _vm.appDeliveryTable.columns,
                  dataSource: _vm.appDeliveryTable.dataSource,
                  maxHeight: 300,
                  disabled: _vm.mainInfoDisable,
                  rowNumber: true,
                  rowSelection: !_vm.mainInfoDisable,
                  actionButton: !_vm.mainInfoDisable,
                  maxNumber: 10
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }